<template>
  <FormKit
    v-if="cancelContractReasons"
    type="select"
    :disabled="state === 'validation'"
    :label="$t('dbc-cancel-contract-select-reason-label')"
    :placeholder="$t('dbc-cancel-contract-select-reason-default')"
    validation="required"
    name="reason"
    :options="cancelContractReasons"
    @change="onChange"
    v-model="selectedOption"
  />
  <p v-if="status === 'error'" class="formkit-message">
    {{ $t('dbc-error-server-issues') }}
  </p>
</template>

<script setup lang="ts">
defineProps<{
  state?: CancelContractStates
}>()

const emit = defineEmits<{
  (e: 'onReasonChanged', reason: CancelContractReason): void
}>()

const selectedOption = ref(null)

function onChange() {
  const selectedReason = cancelContractReasons.value?.find(
    (reason: CancelContractReason) => reason.value === selectedOption.value
  )
  if (selectedReason) {
    emit('onReasonChanged', selectedReason)
  }
}

const { cancelContractReasons, status } = await useFetchCancelContractReasons()
</script>
